module.exports = __webpack_public_path__ + "static/media/loungeService.17f2ee21.png";